import { useRef } from "react"
import { StyledPortionFormItem, PortionLabel } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import DisplayedGramAndCaloriesPerUnit from "components/Common/DisplayedGramAndCaloriesPerUnit"
import PortionIcon from "components/Icons/PortionIcon"
import PortionInput from "../../PortionInput"
import UnitInput from "../../UnitInput"

export interface IProps {
  portionValue: number
  onPortionChange: (portion: number) => void
  unitValue: string
  onUnitChange: (unit: string) => void

  disabled?: boolean

  setIsPortionValid?: (isValid: boolean) => void

  calories?: number
  gram: null | number
}

const MyFoodPortionUnitTextFormItem = (props: IProps) => {
  const {
    onPortionChange,
    portionValue,
    unitValue,
    onUnitChange,
    disabled,
    setIsPortionValid,
    calories,
    gram,
  } = props

  const firstInputRef = useRef<HTMLInputElement>(null)
  const secondInputRef = useRef<HTMLInputElement>(null)

  return (
    <StyledPortionFormItem>
      <FlexBox style={{ width: "100%" }} $justify="space-between">
        <FlexBox $alignItems="center" $gap={4}>
          <PortionIcon />
          <PortionLabel>Portion</PortionLabel>
        </FlexBox>

        <FlexBox $alignItems="center" $gap={12}>
          <PortionInput
            disabled={disabled}
            ref={firstInputRef}
            value={portionValue}
            onChange={onPortionChange}
            setIsPortionValid={setIsPortionValid}
          />

          <UnitInput
            ref={secondInputRef}
            value={unitValue}
            onChange={onUnitChange}
            setIsPortionValid={setIsPortionValid}
          />
        </FlexBox>
      </FlexBox>

      <DisplayedGramAndCaloriesPerUnit
        calories={calories}
        portion={portionValue}
        unit={unitValue}
        gram={gram}
        alwayDisplayGram
      />
    </StyledPortionFormItem>
  )
}

export default MyFoodPortionUnitTextFormItem
